import { render, staticRenderFns } from "./badmintonOrderRecord.vue?vue&type=template&id=119fabe6&"
import script from "./badmintonOrderRecord.vue?vue&type=script&lang=js&"
export * from "./badmintonOrderRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports